import React, { useRef } from "react";

const AppFileSelect = ({ onFileSelect, title, acceptFileType }) => {
	const fileInputRef = useRef();

	// Trigger the file input click programmatically
	const handleSelectClick = () => {
		fileInputRef.current.click();
	};

	// Handle file selection
	const handleFileChange = (event) => {
		if (onFileSelect) {
			onFileSelect(event.target.files[0]);
		}
	};

	return (
		<div>
			{/* Custom Button */}
			<button
				onClick={handleSelectClick}
				className="border border-dashed border-blue-500 px-4 py-2 rounded-md text-blue-500 text-center cursor-pointer hover:border-blue-700"
			>
				{title}
			</button>

			{/* Hidden File Input */}
			<input
				type="file"
				accept={acceptFileType}
				ref={fileInputRef}
				onChange={handleFileChange}
				className="hidden"
			/>
		</div>
	);
};

export default AppFileSelect;
